import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/concept";

export const pagingconceptSymptom = (searchObject) =>
  axios.post(API_PATH + "/search-by-page-symptom", searchObject);

export const getconceptSymptomId = (conceptSymptomId) =>
  axios.get(API_PATH + "/" + conceptSymptomId);

export const saveconceptSymptom = (conceptSymptom) =>
  axios.post(API_PATH + "/save-or-update-concept-service", conceptSymptom);

export const deleteConceptSymptom = (conceptSymptomId) =>
  axios.delete(API_PATH + "/mark-delete/" + conceptSymptomId);
